import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Output,
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { PersonClient } from '@models/clients';
import { IDVStatus, IdvReviewModalSteps } from '@models/idv';
import {
	IdvReviewModalComponent,
	IdvReviewModalData,
	IdvReviewModalDefaultSizes,
} from '../../idv-review-modal/idv-review-modal.component';
import { IdvRequestModalComponent } from '../idv-modal.component';
import { TestHooks } from './idv-table.hooks';

@Component({
	selector: 'app-idv-table',
	templateUrl: './idv-table.component.html',
	styleUrls: ['./idv-table.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IdvTableComponent {
	testHooks = TestHooks;
	@Input() public clients: PersonClient[] = [];

	@Input() public selectedClients: PersonClient[] = []; // figure naming out

	@Input() public hasCheckboxes = true; // figure naming out
	@Input() public allClientsSelected = false; // figure naming out

	@Output() public addClientEvent = new EventEmitter<PersonClient>();
	@Output() public selectAllEvent = new EventEmitter<boolean>();
	@Output() public reviewModalEvent = new EventEmitter<boolean>();

	public ICON = ICON;
	public idvStatus = IDVStatus;

	constructor(
		private matDialog: MatDialog,
		public dialogRef: MatDialogRef<IdvRequestModalComponent>,
	) {}

	addClient(client: PersonClient): void {
		this.addClientEvent.emit(client);
	}

	selectAllClients(): void {
		this.selectAllEvent.emit(this.allClientsSelected);
	}

	reviewModalOpened(): void {
		this.reviewModalEvent.emit(true);
	}

	reviewReport(client: PersonClient): void {
		this.closeModal();

		const data: IdvReviewModalData = {
			googleSrcUrl: client?.idv?.reportUrl,
			fileName: `${client.firstName}-${client.lastName}-report.pdf`,
			fileType: 'application/pdf',
			client: client,
			modalStep: IdvReviewModalSteps.REVIEW_REPORT,
		};
		this.matDialog.open(IdvReviewModalComponent, {
			...IdvReviewModalDefaultSizes,
			data,
		});
	}

	viewReport(client: PersonClient): void {
		this.closeModal();

		const data: IdvReviewModalData = {
			googleSrcUrl: client?.idv?.reportUrl,
			fileName: `${client.firstName}-${client.lastName}-report.pdf`,
			fileType: 'application/pdf',
			client: client,
			modalStep: IdvReviewModalSteps.REVIEW_REPORT,
			viewOnly: true,
		};
		this.matDialog.open(IdvReviewModalComponent, {
			...IdvReviewModalDefaultSizes,
			data,
		});
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	hasClientsSelected(client: PersonClient): boolean {
		return this.selectedClients.some(
			(selectedClient) => selectedClient.id === client.id,
		);
	}
}
